import {useState} from "react";
import {addApi, getSizesApi} from "@/features/add-to-waitList/api/waitListApi";
import {useWaitListStore} from "@/Stores/Site/Profile";
import {useNotSizeStore} from "@/Stores/Site/Product";
import {waitListEvents} from "@/shared/lib/events";

export function useAddToWaitList() {
    const [loading, setLoading] = useState(false);

    const openAddWaitListModal = useWaitListStore(state => state.openAddWaitListModal);
    const openModalNotSize = useNotSizeStore(state => state.openModalNotSize);

    const addToWaitList = async ({productId, size = null}) => {
        try {
            if (loading) return;

            setLoading(true);

            if (size) {
                await handleAdd({productId, size});
                return;
            }

            const response = await getSizesApi(productId);
            const {success} = response.data;
            const {status = false, data = []} = success;

            if (!status) {
                return handleError();
            }

            if (!data.length) {
                await handleAdd({productId});
                return;
            }

            openModalNotSize({
                productId,
                productData: data
            });

        } catch (e) {
            handleError();
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = async ({productId, size = null}) => {
        try {
            const response = await addApi({
                id_product: productId,
                size,
            });

            const {success} = response.data;
            const {status = false, data = [], errors = []} = success;

            if (!status) {
                openAddWaitListModal({
                    title: errors.title,
                    message: errors.errorMessage?.[0],
                });
                return;
            }

            openAddWaitListModal({
                title: data.title,
                message: data.message,
            });

            // Событие (украшение добавлено в лист ожидания)
            waitListEvents.added.emit();
        } catch (e) {
            handleError();
        }
    };

    const handleError = (
        {
            title = 'Внимание',
            message = 'Не удалось добавить украшение в лист ожидания!',
        } = {}
    ) => {
        openAddWaitListModal({
            title,
            message,
        });
    };

    return {addToWaitList, loading};
}
